export const DB_NAME = 'mangaDB';
export const DB_VERSION = 1;

export const STORE_TABS = 'tabs';
export const STORE_PAGES = 'pages';
export const STORE_BOOKMARKS = 'bookmarks';
export const STORE_CHAPTERS = 'chapters';
export const STORE_USERTABS = 'userTabs';
export const STORE_ARTISTS = 'artist';
export const STORE_TAGS = 'tag';

export const PREVIEW_MAX_SIZE = 300;

export const USE_SEEDS = false;